var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel (3) 1",
    clipPath: "url(#clip0_10457_3353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1444 10.3788L16.5389 14.9843L21.1444 19.5897L19.5909 21.1435L14.9854 16.538L10.3801 21.1435L8.82619 19.5897L13.4317 14.9843L8.82619 10.3788L10.3801 8.82528L14.9854 13.4308L19.5909 8.82528L21.1444 10.3788ZM29.0469 14.9854C29.0469 18.7415 27.5841 22.2731 24.928 24.929C22.2721 27.5851 18.7405 29.0479 14.9844 29.0479C11.2283 29.0479 7.69666 27.5851 5.04072 24.929C2.3846 22.2731 0.921875 18.7415 0.921875 14.9854C0.921875 11.2292 2.3846 7.69764 5.04072 5.04169C7.69666 2.38558 11.2283 0.922852 14.9844 0.922852C18.7405 0.922852 22.2721 2.38558 24.928 5.04169C27.5841 7.69764 29.0469 11.2292 29.0469 14.9854ZM26.8496 14.9854C26.8496 8.44299 21.5267 3.12012 14.9844 3.12012C8.44202 3.12012 3.11914 8.44299 3.11914 14.9854C3.11914 21.5277 8.44202 26.8506 14.9844 26.8506C21.5267 26.8506 26.8496 21.5277 26.8496 14.9854Z",
    fill: "#6C6C6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10457_3353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingClose);
export default __webpack_public_path__ + "static/media/ratingClose.ff90c2959a4964941754e0043d876c3d.svg";
export { ForwardRef as ReactComponent };